"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Step = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Step = function Step(_ref) {
  var index = _ref.index,
      currentStep = _ref.currentStep,
      steps = _ref.steps;
  var className = 'step step' + index;
  className += index <= currentStep ? ' active' : '';
  className += index < currentStep ? ' checked' : '';
  var style = {
    left: 100 / (steps - 1) * index + '%'
  };
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", null));
};

exports.Step = Step;
Step.propTypes = {
  index: _propTypes["default"].number.isRequired,
  currentStep: _propTypes["default"].number.isRequired,
  steps: _propTypes["default"].number.isRequired
};
var _default = Step;
exports["default"] = _default;
//# sourceMappingURL=StepperStep.js.map